import { FC } from "react"
import Button, { ButtonIconPosition } from "@/components/shared/Button"
import Grid from "@/components/shared/Grid"
import GridItem from "@/components/shared/Grid/GridItem"
import SearchInput from "@/components/shared/SearchInput"

type HeaderProps = {
   addDisabled: boolean
   setCreateCustomerMode: (mode: boolean) => void
   setSearchValue: (value: string) => void
}

const Header: FC<HeaderProps> = ({
   addDisabled,
   setCreateCustomerMode,
   setSearchValue,
}) => {
   return (
      <GridItem
         className="control-panel__header"
         size={12}
      >
         <h1 className="control-panel__title">Tenant admin control panel</h1>
         <Grid className="control-panel__header-actions">
            <GridItem
               xs={6}
               sm={5}
               md={2}
               lg={2}
            >
               <SearchInput
                  placeholder="Search a customer or a facility"
                  onSearch={(value) => setSearchValue(value)}
               />
            </GridItem>
            <GridItem
               xs={0}
               sm={2}
               md={8}
               lg={8}
            />
            <GridItem
               className="control-panel__add-customer-button-container"
               xs={6}
               sm={5}
               md={2}
               lg={2}
            >
               <Button
                  disabled={addDisabled}
                  iconName="plus"
                  iconPosition={ButtonIconPosition.LEFT}
                  onClick={() => setCreateCustomerMode(true)}
               >
                  Add customer
               </Button>
            </GridItem>
         </Grid>
      </GridItem>
   )
}

export default Header
